import { ChangeEvent, FC, useState } from 'react';
import DatePicker from '../../../../../common/date-picker/date-picker';
import Input from '../../../../../common/input/input';
import translation from '../../../../../languages';
import { CARD_FORM_NAMES } from '../constants/kushki';
import '../kushki.scss';
import { KushkiCardType } from '../types/kushki-types';

type KushkiCardProps = TranslationProps & {
    CVCLength: number;
    cardData: KushkiCardType;
    formErrors: string[];
    onCardDataChange: (name: string, value: string) => void;
};

const KushkiCard: FC<KushkiCardProps> = ({ formErrors, onCardDataChange, CVCLength, cardData, t }) => {
    const [date, setDate] = useState<Date | null>(null);

    const handleUpdateForm = (e: ChangeEvent<HTMLInputElement>) => {
        onCardDataChange(e.target.name, e.target.value);
    };

    const handleDateChange = (date: Date) => {
        setDate(date);
        onCardDataChange(
            CARD_FORM_NAMES.POST_DATE,
            `${date.getMonth() + 1}/${date.getFullYear().toString().substring(2)}`
        );
    };

    return (
        <div>
            <div className='payment-flex mb-4'>
                <div className='mr-3'>
                    <span>{t('payment.kushki.cash.firstName')}</span>
                    <Input
                        className='payment-input-grope'
                        error={formErrors.includes(CARD_FORM_NAMES.FIRST_NAME)}
                        name={CARD_FORM_NAMES.FIRST_NAME}
                        type='text'
                        value={cardData.firstName}
                        onChange={handleUpdateForm}
                    />
                </div>
                <div>
                    <span>{t('payment.kushki.cash.lastName')}</span>
                    <Input
                        className='payment-input-grope'
                        error={formErrors.includes(CARD_FORM_NAMES.LAST_NAME)}
                        name={CARD_FORM_NAMES.LAST_NAME}
                        type='text'
                        value={cardData.lastName}
                        onChange={handleUpdateForm}
                    />
                </div>
            </div>

            <div className='payment-flex mb-4'>
                <div>
                    <span>{t('payment.kushki.card.cardNumber')}</span>
                    <Input
                        autoComplete='cc-number'
                        className='payment-input'
                        error={formErrors.includes(CARD_FORM_NAMES.NUMBER)}
                        inputMode='numeric'
                        maxLength={19}
                        name={CARD_FORM_NAMES.NUMBER}
                        pattern='[0-9]*'
                        type='tel'
                        value={cardData.number}
                        onChange={handleUpdateForm}
                    />
                </div>
            </div>

            <div className='payment-flex mb-4'>
                <div>
                    <span>{t('payment.kushki.card.expiryDate')}</span>
                    <div className='mr-3 designed-datepicker-input'>
                        <DatePicker
                            isMonthYearPicker
                            className='designed-datepicker payment-input-grope'
                            dateFormat='MM/yy'
                            hasError={formErrors.includes(CARD_FORM_NAMES.POST_DATE)}
                            id={CARD_FORM_NAMES.POST_DATE}
                            selected={date}
                            onChange={(date: Date | null) => handleDateChange(date as Date)}
                        />
                    </div>
                </div>
                <div>
                    <span>{t('payment.kushki.card.cvc')}</span>
                    <Input
                        className='payment-input-grope'
                        error={formErrors.includes(CARD_FORM_NAMES.CVC)}
                        maxLength={CVCLength}
                        name={CARD_FORM_NAMES.CVC}
                        type='password'
                        value={cardData.cvc}
                        onChange={handleUpdateForm}
                    />
                </div>
            </div>
        </div>
    );
};

const translate = translation('payment');

export default translate(KushkiCard);
